import {Close as CloseIcon} from '@mui/icons-material';
import {Box, IconButton, Typography} from '@mui/material';

interface JobDetailDialogHeaderProps {
  onClose: () => void;
}

export default function JobDetailDialogHeader({onClose}: JobDetailDialogHeaderProps) {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
      <Typography variant="h6">Job Details</Typography>
      <IconButton onClick={onClose} size="small">
        <CloseIcon />
      </IconButton>
    </Box>
  );
}
